export default __webpack_public_path__ + "static/media/Istelle Brand.77a48684.jpeg";